import React from 'react';
import ComparisonCard from './comparison-card';
import CurrentCard from './current-card';
import { CM2Dataset } from '@interfaces/central-monitoring';

interface IProps {
    studyRef: string;
    canEdit: boolean;
    dataset?: CM2Dataset;
    comparisonDataset?: CM2Dataset;
}

const ReviewCards = ({ studyRef, canEdit, dataset, comparisonDataset }: IProps) => {
    return (
        <>
            <ComparisonCard studyRef={studyRef} comparisonDataset={comparisonDataset} />

            <CurrentCard studyRef={studyRef} dataset={dataset} canEdit={canEdit} />
        </>
    );
};

export default ReviewCards;
